var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "timeline-item" }, [
    _c("span", { staticClass: "timeline-item__date" }, [
      _vm._v(_vm._s(_vm.date))
    ]),
    _vm._v(" "),
    _c("h3", { staticClass: "timeline-item__title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("p", {
      staticClass: "timeline-item__message",
      domProps: { innerHTML: _vm._s(_vm.message) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-791c0f24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-791c0f24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/components/UpdatesTab.Timeline.Item.vue
// module id = ZTLI
// module chunks = 1